import { useEffect, useRef } from "react";
import { useToast } from "./ToastContext";

/** Zgłasza zmianę błędu raz; odświeżanie statusu nie powiela tego samego komunikatu. */
export default function ErrorToast({ message }) {
  const { notify } = useToast();
  const previous = useRef(null);
  useEffect(() => {
    if (message && message !== previous.current) notify(message, "danger");
    previous.current = message;
  }, [message, notify]);
  return null;
}
